import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/basic-salary-formulas',
    name: 'basic-salary-formula',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/basic-salary-formula/index.vue')
  }
]
